import React, { useState } from 'react';
import { func } from 'prop-types';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import BobConfirmButton from '../../../components/BobConfirmButton';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as BobActions from '../../../actions/bobActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityModal.module.css';

const DeleteSensorModal = ({
    clearErrors,
    deleteSensor,
    isLoading,
    onClose,
    sensor,
    refreshOverview,
    site,
    toggleLoading
}) => {
    const [hasError, setHasError] = useState();
        
    const handleDelete = async () => {
        let isDeleted;

        if (!isLoading) {
            toggleLoading(true);
            hasError ? isDeleted = await deleteSensor(sensor.id, { deleteRelatedCalcSensors: true }) : isDeleted = await deleteSensor(sensor.id);
        }

        toggleLoading(false);

        if (typeof isDeleted === 'boolean' && isDeleted) {
            await refreshOverview();
            handleClose();
        } else {
            setHasError(true);
        }
    };

    const handleClose = () => {
        clearErrors();
        toggleLoading(false);
        onClose();
    };

    return (
        <React.Fragment>
            <ErrorOutlineIcon className={classes.warningIcon} />
            <div className={classes.text}>
                <p className={classes.desc}> Are you sure you want to delete the entity below?</p>
                <p className={classes.name}>Sensor</p>
                <p className={classes.entityName}>{sensor.name}</p>
                {
                    hasError ?
                        <div className={classes.errorText}>
                            <div>This sensor is related to one or more calculated sensors.</div>
                            <div>Deleting this sensor will also delete those related</div>
                            <div>calculated sensors. Are you sure you want to delete?</div>
                        </div>
                        :
                        null
                }
            </div>
            <Button
                className={classes.Button}
                onClick={handleClose}
                variant="contained"
            >
                Cancel
            </Button>
            <BobConfirmButton
                className={classes.ButtonWithMargin}
                isLoading={isLoading}
                label={'Yes'}
                iconSize={20}
                onClick={handleDelete}
            />
        </React.Fragment>
    );
};

DeleteSensorModal.propTypes = {
    onClose: func.isRequired
};

const mapStateToProps = state => {
    return {
        isLoading: state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...BobActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSensorModal);
